import { Fancybox } from "@fancyapps/ui"
import "@fancyapps/ui/dist/fancybox/fancybox.css"

Fancybox.defaults.autoFocus = false
Fancybox.defaults.placeFocusBack = false
Fancybox.defaults.Toolbar = {
  display: {
    left: ['infobar'],
    middle: [],
    right: ['iterateZoom', 'slideshow', 'fullscreen', 'download', 'thumbs', 'close']
  }
}

export default Fancybox
